import { Component, OnInit, OnDestroy } from '@angular/core';
import { AppState } from 'src/app/app.reducer';
import { Store } from '@ngrx/store';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { GetConfigurations, UpdateConfigurations } from '../store/configurations.actions';
import { Subscription, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ENTER, COMMA } from '@angular/cdk/keycodes';
import { MatChipInputEvent } from '@angular/material';

@Component({
    selector: 'app-list-configurations',
    templateUrl: './list-configurations.component.html',
    styleUrls: ['./list-configurations.component.scss']
})

export class ListConfigurationsComponent implements OnDestroy{
  
    configList: Array<any> = [];
    groupArr: Array<any> = [];
    bccEmail;
    selectable = true;
    removable = true;
    visible = true;
    configValChanged: boolean = false;
    stopper$: Subject<any> =new Subject();
    arrayValues: any = [];
    readonly separatorKeysCodes: number[] = [ENTER, COMMA];
    constructor(
        private store: Store<AppState>,
        private router: Router,
        private fb: FormBuilder
    ) { }

    ngOnInit() {
        this.bccEmail = new FormControl(); 

        this.store.dispatch(new GetConfigurations());

        this.store.select(state => state.configurations.configurations).pipe(takeUntil(this.stopper$)).subscribe((configList) => {
            configList = Object.values(configList);
            
            if (configList.length) {
                this.configList = configList;   
            }

            console.log(this.configList);
            

            this.groupArr = this.configList.reduce((r,{groupName})=>{
                if(!r.some(o=>o.groupName==groupName)){
                  r.push({groupName,groupItem:this.configList.filter(v=>v.groupName==groupName)});
            }
            return r;
            },[]);

            console.log(this.groupArr);

            
            this.groupArr.sort((a, b) => (a.groupName > b.groupName) ? 1 : -1)
        });
    }

    updateConfiguration(key, value) {

        //passwordMaxLength
        //passwordMinLength


        if (key == 'bcc' && !this.bccEmail.valid) {
            return;

        }

        if (typeof(value) === 'number' && value < 0) {
            return;
        }

        if (typeof(value) !== 'number' &&  !value) {
            return;
        }

        if (key == 'passwordMaxLength' && value === 0 || key == 'passwordMinLength' && value === 0 ) {
            return;
        }


        const updatedConfig = {}

        updatedConfig[key] = value;

        this.store.dispatch(new UpdateConfigurations(updatedConfig))
    }

    getValues(values){
        this.arrayValues = values.split(",");
        return this.arrayValues;
    }

    add(event: MatChipInputEvent): void {
        const input = event.input;
        const value = event.value;
    
        // Add our fruit
        if ((value || '').trim()) {
            this.arrayValues.push(value.trim());
        }
    
        // Reset the input value
        if (input) {
          input.value = '';
        }
      }

    remove(itemInex): void {
        // const index = list.indexOf(fruit);
    
        // if (index >= 0) {
          this.arrayValues.splice(itemInex, 1);
        // }
      }
    ngOnDestroy() {
        this.stopper$.next();
        this.stopper$.complete();
    }
}
